import type { Event, EventHint, BrowserClient } from '@sentry/vue'
import type { ContextoErro } from '@next/compartilhados/observabilidade'
import { FalhaHttp } from '@next/infraestrutura/http'

export type ProjetarErroLegado = (erro: unknown, contexto: ContextoErro) => Readonly<{
  erro: unknown
  tipo?: string
  origemStack?: ContextoErro['origemStack']
}>

/** Usa o parser do SDK, sem recapturar a exceção nem serializar sua causa/resposta. */
export const projetarExcecao = async (
  evento: Event, hint: EventHint, contexto: ContextoErro, cliente: Pick<BrowserClient, 'eventFromException'>,
  projetarLegado?: ProjetarErroLegado,
): Promise<{ evento: Event; origemStack?: ContextoErro['origemStack'] }> => {
  try {
    const original = hint.originalException
    const projecao: ReturnType<ProjetarErroLegado> = original instanceof FalhaHttp && original.causa instanceof Error
      ? { erro: original.causa, origemStack: 'causa' as const }
      : projetarLegado?.(original, contexto) ?? { erro: original }
    const convertido = projecao.erro !== original ? await cliente.eventFromException(projecao.erro, hint) : evento
    const valores = convertido.exception?.values
    return {
      evento: valores ? { ...evento, exception: {
        values: valores.map(valor => ({ ...valor, ...(projecao.tipo ? { type: projecao.tipo } : {}) })),
      } } : evento,
      ...(projecao.origemStack ? { origemStack: projecao.origemStack } : {}),
    }
  } catch {
    // Falha de um dado opcional não pode apagar o evento já construído pelo SDK.
    return { evento }
  }
}
